const completedSteps = (steps, name) => {
  const step = steps?.find(x => x?.name === name);

  return step && step.status === 'Complete' && step.isEnabled;
};

const getEditableSteps = steps => {
  const editableSteps = {};
  if (completedSteps(steps, 'demographics'))
    editableSteps.accountDetails = '/personal-details/entry';
  if (completedSteps(steps, 'protection'))
    editableSteps.ancillaryProducts = '/carvana-protection';
  if (completedSteps(steps, 'paymentCollection')) {
    editableSteps.paymentMethod = '/payment-options';
    editableSteps.paymentCollection = '/down-payment';
  }
  if (completedSteps(steps, 'tradeIn'))
    editableSteps.tradeIn = '/trade-in';
  if (completedSteps(steps, 'transferMethod'))
    editableSteps.transferMethod = '/transfer-method';
  if (completedSteps(steps, 'paymentSchedule'))
    editableSteps.paymentSchedule = '/payment-schedule';

  return editableSteps;
};

export default getEditableSteps;
